<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="ms-3">
      @if (currentAccount?.notificationByApp) {
        <div
          ngbDropdown
          #notificationBoard="ngbDropdown"
          (mouseenter)="$event.stopPropagation(); notificationBoard.open()"
          (mouseleave)="$event.stopPropagation(); notificationBoard.close()"
        >
          <a
            ngbDropdownAnchor
            class="btn nav-link position-relative"
            role="button"
            [routerLink]="['/app-notification']"
          >
            <i class="feather-bell font-22"></i>
            @if (unreadUserAppNotificationsCount) {
              <span
                class="position-absolute badge-position translate-middle badge rounded-pill bg-danger"
              >
                {{
                  unreadUserAppNotificationsCount < 100
                    ? unreadUserAppNotificationsCount
                    : "99+"
                }}
                <span class="visually-hidden">unread in-app notifications</span>
              </span>
            }
          </a>
          <div
            ngbDropdownMenu
            [class.d-none]="!userAppNotifications.length"
            class="dropdown-menu dropdown-menu-end m-0"
          >
            @for (
              userAppNotification of userAppNotifications;
              track userAppNotification.id
            ) {
              <a
                ngbDropdownItem
                (click)="openNotificationDetailModal(userAppNotification)"
                [class.bold]="!userAppNotification.readFlag"
                class="dropdown-item text-truncate mw-400"
                href="javascript:void(0)"
              >
                {{ userAppNotification.title }}
              </a>
            }
          </div>
        </div>
      }
      @if (showClientMessages) {
        <a
          [routerLink]="['/client-message']"
          class="btn nav-link position-relative"
        >
          <i class="feather-mail font-22"></i>
          @if (unreadMessagesCount$ | async; as unreadMessagesCount) {
            <span
              class="position-absolute badge-position translate-middle badge rounded-pill bg-danger"
            >
              {{ unreadMessagesCount < 100 ? unreadMessagesCount : "99+" }}
              <span class="visually-hidden">unread messages</span>
            </span>
          }
        </a>
      }
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    @if (!hidenav && currentAccount) {
      <app-breadcrumb></app-breadcrumb>
    }
  </c-container>
</ng-container>

<ng-template #userDropdown>
  <ul class="nav navbar-nav ms-auto">
    <li class="nav-item me-3" ngbDropdown>
      <button
        (click)="(false)"
        class="nav-link outline-0 btn"
        ngbDropdownToggle
        data-qaa="userButton"
      >
        @if (currentAccount) {
          <span class="d-none d-sm-inline"
            >{{ currentAccount?.firstName }}
            {{ currentAccount?.lastName }}</span
          >
        }
        &nbsp; <i class="feather-settings"></i>
      </button>

      <div ngbDropdownMenu class="mt-2">
        <a
          [routerLink]="['/settings']"
          class="dropdown-item"
          data-qaa="userGoogleEmailSyncButton"
          ><i class="feather-user"></i> Profile</a
        >
        @if (
          currentAccount?.firmSettings?.emailSyncProvider === "O365" &&
          !currentUserIsLimitedAccess
        ) {
          <a
            ngbDropdownItem
            [routerLink]="['/system/integrations/office365']"
            data-qaa="userOffice365SyncButton"
            ><i class="feather-refresh-cw"></i> Office 365 Sync</a
          >
        }
        @if (
          currentAccount?.firmSettings?.emailSyncProvider === "GMAIL" &&
          !currentUserIsLimitedAccess
        ) {
          <a
            [routerLink]="['/system/integrations/google']"
            class="dropdown-item"
            data-qaa="userGoogleEmailSyncButton"
            ><i class="feather-refresh-cw"></i> Google Email Sync</a
          >
        }
        @if (
          currentAccount?.rightsignatureEnabled && !currentUserIsLimitedAccess
        ) {
          <a
            [routerLink]="['/system/integrations/rightsignature']"
            class="dropdown-item"
            data-qaa="userRightSignatureButton"
            ><i class="feather-refresh-cw"></i> Right Signature</a
          >
        }
        @if (currentAccount?.filesyncEnabled && !currentUserIsLimitedAccess) {
          <a
            [routerLink]="['/system/integrations/filesync']"
            class="dropdown-item"
            data-qaa="userFileSyncButton"
            ><i class="feather-refresh-cw"></i> FileSync</a
          >
        }
        <a
          [routerLink]="['/password']"
          class="dropdown-item"
          data-qaa="userChangePasswordButton"
          ><i class="feather-lock"></i> Change Password</a
        >
        <a
          href="https://firm360.zendesk.com/hc/en-us/"
          target="_blank"
          class="dropdown-item"
          data-qaa="userManualButton"
          ><i class="feather-help-circle"></i> User Manual</a
        >
        @if (
          !currentAccount?.firmSettings?.adminOnlyMessageTemplates &&
          showClientMessages
        ) {
          <a
            [routerLink]="[
              '/system/customizations/client-message-template/user',
            ]"
            class="dropdown-item"
            ><i class="feather-file-text"></i> My Message Templates</a
          >
        }

        <button (click)="logout()" ngbDropdownItem data-qaa="userLogoutButton">
          <i class="feather-arrow-left"></i> Logout
        </button>
      </div>
    </li>
  </ul>
</ng-template>
